export default __webpack_public_path__ + "static/media/restaurant-thumbnail.ef82cb68.jpg";